import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const SupplierManagement = () => {
    return <AdminModulePage moduleKey="supplier-management" />;
};

export default SupplierManagement;
